var map = {
	"./Account/PlayerType/beginner_player.svg": 12707,
	"./Account/PlayerType/pro_player.svg": 63780,
	"./Account/PlayerType/pro_player_disabled.svg": 4731,
	"./Animation/10s": 62144,
	"./Animation/10s.json": 62144,
	"./Animation/20s": 17141,
	"./Animation/20s.json": 17141,
	"./Animation/30s": 90594,
	"./Animation/30s.json": 90594,
	"./Animation/Blitz": 2149,
	"./Animation/Blitz.json": 2149,
	"./Animation/Bullet": 42338,
	"./Animation/Bullet.json": 42338,
	"./Animation/CaissaHello_animation.riv": 65287,
	"./Animation/CaissaSuccess_animation.riv": 98902,
	"./Animation/Calculation_Trainer/Calculation_Trainer": 5581,
	"./Animation/Calculation_Trainer/Calculation_Trainer.json": 5581,
	"./Animation/Challenge_a_friend.riv": 2976,
	"./Animation/Classical": 22099,
	"./Animation/Classical.json": 22099,
	"./Animation/Didnt_find_any_opponent.riv": 91394,
	"./Animation/Intuition_Trainer/Intuition_Trainer": 47981,
	"./Animation/Intuition_Trainer/Intuition_Trainer.json": 47981,
	"./Animation/Play_against_Caissa_Bot.riv": 2715,
	"./Animation/Play_random_opponent.riv": 52002,
	"./Animation/Practice_from_a_position.riv": 54138,
	"./Animation/Rapid": 41028,
	"./Animation/Rapid.json": 41028,
	"./Animation/Search": 33993,
	"./Animation/Search.json": 33993,
	"./Animation/Snail": 69511,
	"./Animation/Snail.json": 69511,
	"./Animation/Solve_Puzzles/Solve_Puzzles": 61465,
	"./Animation/Solve_Puzzles/Solve_Puzzles.json": 61465,
	"./Animation/Square_Trainer/Square_training": 10266,
	"./Animation/Square_Trainer/Square_training.json": 10266,
	"./Animation/Start_new_game/v1": 55754,
	"./Animation/Start_new_game/v1.json": 55754,
	"./Animation/Start_new_game/v2": 5243,
	"./Animation/Start_new_game/v2.json": 5243,
	"./Animation/caissa_animation.riv": 33393,
	"./Animation/challenge_animation.riv": 20564,
	"./Animation/challenge_wait": 28025,
	"./Animation/challenge_wait.json": 28025,
	"./Animation/chessboardLoader": 11241,
	"./Animation/chessboardLoader.json": 11241,
	"./Animation/chessboardLoader2": 20897,
	"./Animation/chessboardLoader2.json": 20897,
	"./Animation/circlechess_opponent_matching_animation.riv": 82281,
	"./Animation/didnt_respond.riv": 83799,
	"./Animation/error_boundary_animation": 33406,
	"./Animation/error_boundary_animation.json": 33406,
	"./Animation/error_page_404.lottie": 75469,
	"./Animation/mobileMenuIcon": 66270,
	"./Animation/mobileMenuIcon.json": 66270,
	"./Animation/rejected_your_challenge.riv": 58430,
	"./Animation/successCheck": 76551,
	"./Animation/successCheck.json": 76551,
	"./Animation/under_construction": 66384,
	"./Animation/under_construction.json": 66384,
	"./Annotation/attack.svg": 96615,
	"./Annotation/black_is_better.svg": 30252,
	"./Annotation/black_is_slightly_better.svg": 28711,
	"./Annotation/black_is_winning.svg": 45622,
	"./Annotation/blunder.svg": 33245,
	"./Annotation/brilliant_move.svg": 61156,
	"./Annotation/counter_play.svg": 53482,
	"./Annotation/development.svg": 66774,
	"./Annotation/dubious_move.svg": 2228,
	"./Annotation/equal_position.svg": 80577,
	"./Annotation/good_move.svg": 55364,
	"./Annotation/initiative.svg": 53069,
	"./Annotation/interesting_move.svg": 48777,
	"./Annotation/mistake.svg": 71025,
	"./Annotation/only_move.svg": 78063,
	"./Annotation/time_trouble.svg": 39556,
	"./Annotation/unclear_position.svg": 95589,
	"./Annotation/white-color/attack_white.svg": 92925,
	"./Annotation/white-color/black_is_better_white.svg": 86594,
	"./Annotation/white-color/black_is_slightly_better_white.svg": 78269,
	"./Annotation/white-color/black_is_winning_white.svg": 85428,
	"./Annotation/white-color/blunder_white.svg": 4083,
	"./Annotation/white-color/brilliant_move_white.svg": 47298,
	"./Annotation/white-color/counter_play_white.svg": 4032,
	"./Annotation/white-color/development_white.svg": 21020,
	"./Annotation/white-color/dubious_move_white.svg": 13634,
	"./Annotation/white-color/equal_position_white.svg": 32583,
	"./Annotation/white-color/good_move_white.svg": 35162,
	"./Annotation/white-color/initiative_white.svg": 78555,
	"./Annotation/white-color/interesting_move_white.svg": 37471,
	"./Annotation/white-color/mistake_white.svg": 99671,
	"./Annotation/white-color/only_move_white.svg": 52733,
	"./Annotation/white-color/time_trouble_white.svg": 44338,
	"./Annotation/white-color/unclear_position_white.svg": 54099,
	"./Annotation/white-color/white_is_better_white.svg": 17932,
	"./Annotation/white-color/white_is_slightly_better_white.svg": 21783,
	"./Annotation/white-color/white_is_winning_white.svg": 89022,
	"./Annotation/white-color/with_compensation_white.svg": 57042,
	"./Annotation/white-color/with_the_idea_white.svg": 55805,
	"./Annotation/white-color/zugzwand_white.svg": 80651,
	"./Annotation/white_is_better.svg": 49630,
	"./Annotation/white_is_slightly_better.svg": 26449,
	"./Annotation/white_is_winning.svg": 49048,
	"./Annotation/with_compensation.svg": 31444,
	"./Annotation/with_the_idea.svg": 29311,
	"./Annotation/zugzwand.svg": 49629,
	"./Badges/1stPrize.png": 94761,
	"./Badges/2ndPrize.png": 60949,
	"./Badges/3rdPrize.png": 73066,
	"./ChessPieces/Black-Bishop.svg": 31458,
	"./ChessPieces/Black-King.svg": 98652,
	"./ChessPieces/Black-Knight.svg": 72510,
	"./ChessPieces/Black-Pawn.svg": 95823,
	"./ChessPieces/Black-Queen.svg": 55305,
	"./ChessPieces/Black-Rook.svg": 14310,
	"./ChessPieces/White-Bishop.svg": 90200,
	"./ChessPieces/White-King.svg": 12274,
	"./ChessPieces/White-Knight.svg": 65532,
	"./ChessPieces/White-Pawn.svg": 37097,
	"./ChessPieces/White-Queen.svg": 60515,
	"./ChessPieces/White-Rook.svg": 41640,
	"./Dashboard/BeginnerOrPro/beginner_image.svg": 52361,
	"./Dashboard/BeginnerOrPro/pro_image.svg": 22544,
	"./Dashboard/PlayOnline/chessboardBg__PlayChess.svg": 66213,
	"./Dashboard/PlayOnline/playChessIcon.svg": 37507,
	"./Dashboard/SolvePuzzle/puzzleBg.svg": 24125,
	"./Dashboard/StreakDropdownBg/streak_dropdown_bg.svg": 94271,
	"./Eco/eco": 74228,
	"./Eco/eco.json": 74228,
	"./Fonts/DMSans-Medium.ttf": 38817,
	"./Fonts/DMSans-Regular.ttf": 53700,
	"./Fonts/DMSans-SemiBold.ttf": 57495,
	"./Fonts/ProductSans-Black.ttf": 65283,
	"./Fonts/ProductSans-BlackItalic.ttf": 73659,
	"./Fonts/ProductSans-Bold.ttf": 85075,
	"./Fonts/ProductSans-BoldItalic.ttf": 49611,
	"./Fonts/ProductSans-Italic.ttf": 43906,
	"./Fonts/ProductSans-Light.ttf": 85378,
	"./Fonts/ProductSans-LightItalic.ttf": 15182,
	"./Fonts/ProductSans-Medium.ttf": 79575,
	"./Fonts/ProductSans-MediumItalic.ttf": 37615,
	"./Fonts/ProductSans-Regular.ttf": 56762,
	"./Fonts/ProductSans-Thin.ttf": 41519,
	"./Fonts/ProductSans-ThinItalic.ttf": 75799,
	"./Fonts/THUNDER/Fonts/Web-TT/Thunder-LC.ttf": 57327,
	"./Fonts/THUNDER/Fonts/Web-TT/Thunder-LC.woff": 7357,
	"./Fonts/THUNDER/Fonts/Web-TT/Thunder-LC.woff2": 66437,
	"./Fonts/THUNDER/License/License.pdf": 43215,
	"./Fonts/fontWeightToFamily": 21511,
	"./Fonts/fontWeightToFamily.ts": 21511,
	"./Images/Caissa/Caissa_bot_girl.svg": 72226,
	"./Images/Caissa/Caissa_bot_horse.svg": 31699,
	"./Images/Caissa/PlayAndLearnTabPatternMobile.svg": 10617,
	"./Images/Caissa/PlayModeIcon.svg": 22011,
	"./Images/Caissa/TournamenTab.svg": 77767,
	"./Images/Caissa/aqua_chess_pattern.svg": 81037,
	"./Images/Caissa/chatbot/Parental_control_rules.svg": 45442,
	"./Images/Caissa/chatbot/chessboard_stairs_chatbot_bg.svg": 23366,
	"./Images/ChessPieces/Black-Rook.png": 25562,
	"./Images/ChessPieces/Black-Rook.svg": 99093,
	"./Images/ChessPieces/White-Rook.png": 87800,
	"./Images/ChessPieces/White-Rook.svg": 17911,
	"./Images/ChessPieces/whiterookscale.svg": 15302,
	"./Images/Meetings/Coach.svg": 66857,
	"./Images/Meetings/Instructor.svg": 81340,
	"./Images/Meetings/Mentor.svg": 49734,
	"./Images/Meetings/Pattern.svg": 18149,
	"./Images/Meetings/Practice.svg": 11258,
	"./Images/Otb/card_pattern.svg": 617,
	"./Images/Otb/corner_pattern.svg": 72532,
	"./Images/Otb/otb_image.svg": 99683,
	"./Images/Points/negativePoint.png": 15038,
	"./Images/Points/positivePoint.png": 99538,
	"./Images/RequestAccess/NoPlayer.svg": 26262,
	"./Images/ReviewGame.png": 16105,
	"./Images/Rules-image.png": 61762,
	"./Images/Svgs/BeginnerDashboard/Background.svg": 86197,
	"./Images/Svgs/BeginnerDashboard/Chessboard.svg": 41241,
	"./Images/Svgs/BeginnerDashboard/FindSquare.svg": 35653,
	"./Images/Svgs/BeginnerDashboard/Intersect.svg": 80848,
	"./Images/Svgs/BeginnerDashboard/IntersectPattern.svg": 56070,
	"./Images/Svgs/BeginnerDashboard/LearningRoadmap.svg": 15301,
	"./Images/Svgs/BeginnerDashboard/PlayAGame.svg": 31950,
	"./Images/Svgs/BeginnerDashboard/PracticePosition.svg": 4471,
	"./Images/Svgs/BeginnerDashboard/pawnIcon.svg": 20316,
	"./Images/Svgs/Bolt.svg": 74893,
	"./Images/Svgs/Bullet.svg": 69692,
	"./Images/Svgs/CCCurrency": 70576,
	"./Images/Svgs/CCCurrency.tsx": 70576,
	"./Images/Svgs/CCTicketIcon": 41862,
	"./Images/Svgs/CCTicketIcon.tsx": 41862,
	"./Images/Svgs/Ellipse.svg": 44966,
	"./Images/Svgs/ExclamationIcon": 13043,
	"./Images/Svgs/ExclamationIcon.tsx": 13043,
	"./Images/Svgs/IncorrectMove.svg": 81610,
	"./Images/Svgs/IsOngoing.svg": 12823,
	"./Images/Svgs/LeagueDetail.svg": 40691,
	"./Images/Svgs/Parental_control_rules.svg": 88997,
	"./Images/Svgs/Play active.svg": 45500,
	"./Images/Svgs/Play and Learn active.svg": 62231,
	"./Images/Svgs/Play and Learn normal.svg": 82588,
	"./Images/Svgs/Play normal.svg": 67091,
	"./Images/Svgs/Play.svg": 75178,
	"./Images/Svgs/Play_from_any_position.svg": 52092,
	"./Images/Svgs/PlayandLearn.svg": 7777,
	"./Images/Svgs/Rapid.svg": 31266,
	"./Images/Svgs/Rectangle.svg": 21755,
	"./Images/Svgs/Snail.svg": 24287,
	"./Images/Svgs/Summary.svg": 12812,
	"./Images/Svgs/Tournaments.svg": 13964,
	"./Images/Svgs/addMember.svg": 92247,
	"./Images/Svgs/androidqr.jpg": 22131,
	"./Images/Svgs/appModalImage.jpg": 10860,
	"./Images/Svgs/background_frames.svg": 89525,
	"./Images/Svgs/bannerItems/header1.png": 38364,
	"./Images/Svgs/bannerItems/header2.png": 43447,
	"./Images/Svgs/bannerItems/header3.png": 53454,
	"./Images/Svgs/bannerItems/left.png": 81801,
	"./Images/Svgs/bannerItems/right.png": 80786,
	"./Images/Svgs/bannerItems/topHeader.png": 71758,
	"./Images/Svgs/bannerchakra.svg": 47952,
	"./Images/Svgs/beginIg.svg": 27247,
	"./Images/Svgs/blue-chessboard.jpg": 37022,
	"./Images/Svgs/blue.svg": 9960,
	"./Images/Svgs/bottomShadow.svg": 76197,
	"./Images/Svgs/bottombg.svg": 31184,
	"./Images/Svgs/brief_logo.png": 13869,
	"./Images/Svgs/bronzeMedal.svg": 4949,
	"./Images/Svgs/brownleft.svg": 88619,
	"./Images/Svgs/brownright.svg": 73486,
	"./Images/Svgs/caissaAvatar.svg": 15141,
	"./Images/Svgs/cameraPlus.svg": 49509,
	"./Images/Svgs/cc-logo-dark.svg": 29623,
	"./Images/Svgs/cc-logo-light.svg": 52197,
	"./Images/Svgs/ccIcon.svg": 82573,
	"./Images/Svgs/cc_logo.png": 88615,
	"./Images/Svgs/ccleague.svg": 50449,
	"./Images/Svgs/challengehover.svg": 34199,
	"./Images/Svgs/checksquare.svg": 52745,
	"./Images/Svgs/chessboard.svg": 59903,
	"./Images/Svgs/chesscom.png": 33828,
	"./Images/Svgs/chessdotcom.svg": 75784,
	"./Images/Svgs/chevronDoubleDown.svg": 91606,
	"./Images/Svgs/chevronDoubleUp.svg": 6733,
	"./Images/Svgs/circle_chess_back_half.png": 25152,
	"./Images/Svgs/coinBackgoundForGoals.svg": 6148,
	"./Images/Svgs/coinInRewards.svg": 94454,
	"./Images/Svgs/coming_soon.png": 8550,
	"./Images/Svgs/coming_soon_2.png": 38249,
	"./Images/Svgs/congrats.svg": 22619,
	"./Images/Svgs/connection_change.svg": 89163,
	"./Images/Svgs/correct.svg": 99534,
	"./Images/Svgs/crossCircle.svg": 46320,
	"./Images/Svgs/cursorclick.svg": 52962,
	"./Images/Svgs/custom_positions_tournaments.svg": 9369,
	"./Images/Svgs/download.svg": 54732,
	"./Images/Svgs/endgamewhite.svg": 77340,
	"./Images/Svgs/euros.svg": 38598,
	"./Images/Svgs/expert_cheat_detection.svg": 24956,
	"./Images/Svgs/fully_private_games.svg": 60520,
	"./Images/Svgs/gameplay_assistant.svg": 78093,
	"./Images/Svgs/giftIcon.svg": 76797,
	"./Images/Svgs/goldMedal.svg": 90971,
	"./Images/Svgs/green-chessboard.jpg": 27549,
	"./Images/Svgs/green.svg": 82749,
	"./Images/Svgs/greycircle.svg": 17269,
	"./Images/Svgs/hint.svg": 49047,
	"./Images/Svgs/home_page/AI-enabled Caissa.svg": 64062,
	"./Images/Svgs/home_page/Frame.svg": 40263,
	"./Images/Svgs/home_page/Frame1.svg": 98388,
	"./Images/Svgs/home_page/Frame2.svg": 69895,
	"./Images/Svgs/home_page/Frame3.svg": 30358,
	"./Images/Svgs/home_page/PRO.svg": 62185,
	"./Images/Svgs/home_page/Union.svg": 59669,
	"./Images/Svgs/home_page/arrow_down.svg": 45414,
	"./Images/Svgs/home_page/arrow_up.svg": 93021,
	"./Images/Svgs/home_page/assessment.svg": 39774,
	"./Images/Svgs/home_page/badge.svg": 68089,
	"./Images/Svgs/home_page/beginners_curve.svg": 9717,
	"./Images/Svgs/home_page/books_videos.svg": 19849,
	"./Images/Svgs/home_page/bottomLeftSquare.svg": 34755,
	"./Images/Svgs/home_page/bottomRightSquare.svg": 36912,
	"./Images/Svgs/home_page/caissa.svg": 77496,
	"./Images/Svgs/home_page/calculation_trainer.svg": 66645,
	"./Images/Svgs/home_page/chat.svg": 32562,
	"./Images/Svgs/home_page/chess_events.svg": 97276,
	"./Images/Svgs/home_page/chessboard_left_part_large.svg": 35632,
	"./Images/Svgs/home_page/chessboard_part_left.svg": 46868,
	"./Images/Svgs/home_page/chessboard_part_right.svg": 23003,
	"./Images/Svgs/home_page/chessboard_right_part_large.svg": 74461,
	"./Images/Svgs/home_page/cropped_dashboard.svg": 35184,
	"./Images/Svgs/home_page/double_arrow_up.svg": 81771,
	"./Images/Svgs/home_page/four_squares.svg": 50281,
	"./Images/Svgs/home_page/game_analytics.svg": 51663,
	"./Images/Svgs/home_page/game_play.svg": 42255,
	"./Images/Svgs/home_page/intermediate.svg": 6455,
	"./Images/Svgs/home_page/intuition_trainer.svg": 17837,
	"./Images/Svgs/home_page/learning.svg": 2438,
	"./Images/Svgs/home_page/logo.svg": 20101,
	"./Images/Svgs/home_page/organisation_trophy.svg": 92859,
	"./Images/Svgs/home_page/parental_control.svg": 55993,
	"./Images/Svgs/home_page/play.svg": 20318,
	"./Images/Svgs/home_page/player.svg": 66639,
	"./Images/Svgs/home_page/positions_trainer.svg": 90854,
	"./Images/Svgs/home_page/review.svg": 42132,
	"./Images/Svgs/home_page/rules.svg": 99237,
	"./Images/Svgs/home_page/signup_assess.svg": 92653,
	"./Images/Svgs/home_page/signup_elevate.svg": 14539,
	"./Images/Svgs/home_page/square.svg": 55981,
	"./Images/Svgs/home_page/square_background.svg": 29828,
	"./Images/Svgs/home_page/sync_obt.svg": 6781,
	"./Images/Svgs/home_page/tournament.svg": 6481,
	"./Images/Svgs/home_page/two_squares.svg": 92539,
	"./Images/Svgs/iosqr.jpg": 58733,
	"./Images/Svgs/knights_elephant.png": 23749,
	"./Images/Svgs/largest_learning_community.svg": 35351,
	"./Images/Svgs/leagueBackground.svg": 82859,
	"./Images/Svgs/learning/arrow.svg": 66288,
	"./Images/Svgs/learning/assessment.svg": 1107,
	"./Images/Svgs/learning/blunder-icon.svg": 97995,
	"./Images/Svgs/learning/gamified-experience.svg": 80800,
	"./Images/Svgs/learning/inaccuracy-icon.svg": 69643,
	"./Images/Svgs/learning/master-games.svg": 317,
	"./Images/Svgs/learning/mistakes-icon.svg": 45344,
	"./Images/Svgs/learning/personalized-content.svg": 84839,
	"./Images/Svgs/learning/slash.svg": 5500,
	"./Images/Svgs/left.svg": 54271,
	"./Images/Svgs/leftbackground.svg": 65879,
	"./Images/Svgs/levelUnitEmpty.svg": 28391,
	"./Images/Svgs/levelUnitEmptyBrown.svg": 70933,
	"./Images/Svgs/levelUnitFilled.svg": 11020,
	"./Images/Svgs/levelUnitFilledBrown.svg": 64648,
	"./Images/Svgs/lichess.png": 74392,
	"./Images/Svgs/lichess.svg": 4503,
	"./Images/Svgs/logo.svg": 89721,
	"./Images/Svgs/logoicon.svg": 59046,
	"./Images/Svgs/mainappbanner.jpg": 56309,
	"./Images/Svgs/message.svg": 64545,
	"./Images/Svgs/middle.svg": 31547,
	"./Images/Svgs/mobile_bg.svg": 85676,
	"./Images/Svgs/mobile_corner_prize.svg": 663,
	"./Images/Svgs/new_book_icon.svg": 57618,
	"./Images/Svgs/no_issue_selected.svg": 9915,
	"./Images/Svgs/pattern.svg": 43858,
	"./Images/Svgs/pawnpair.svg": 62486,
	"./Images/Svgs/pawns.svg": 12809,
	"./Images/Svgs/peopleGroup.svg": 25354,
	"./Images/Svgs/person_playing_chess.svg": 80953,
	"./Images/Svgs/pink.svg": 84424,
	"./Images/Svgs/playerSelected.svg": 61880,
	"./Images/Svgs/playstore.svg": 83277,
	"./Images/Svgs/points.svg": 54921,
	"./Images/Svgs/pointsCoinIcon.svg": 1961,
	"./Images/Svgs/prize.svg": 50740,
	"./Images/Svgs/prizeapp.svg": 11669,
	"./Images/Svgs/prizereminder.svg": 37454,
	"./Images/Svgs/proIg.svg": 85133,
	"./Images/Svgs/purple.svg": 48290,
	"./Images/Svgs/puzzle_attempts.svg": 94781,
	"./Images/Svgs/puzzle_timer.svg": 53286,
	"./Images/Svgs/quote.png": 25679,
	"./Images/Svgs/rectangles.svg": 63954,
	"./Images/Svgs/reflects_your_rating.svg": 48088,
	"./Images/Svgs/right.svg": 8218,
	"./Images/Svgs/select_avatar.svg": 64232,
	"./Images/Svgs/silhouette-male-icon.svg": 50822,
	"./Images/Svgs/silverMedal.svg": 47972,
	"./Images/Svgs/singular_ecosystem.svg": 28138,
	"./Images/Svgs/speedometer.svg": 36267,
	"./Images/Svgs/squares.svg": 18480,
	"./Images/Svgs/thumsdown.svg": 66593,
	"./Images/Svgs/thumsdownActive.svg": 12743,
	"./Images/Svgs/thumsup.svg": 98110,
	"./Images/Svgs/thumsupActive.svg": 95748,
	"./Images/Svgs/toprightbg.svg": 86716,
	"./Images/Svgs/tournament_banner/Union.svg": 14518,
	"./Images/Svgs/tournament_banner/background_pattern.svg": 29246,
	"./Images/Svgs/tournament_banner/background_pattern_mobile.svg": 61715,
	"./Images/Svgs/tournament_banner/bannerMain.svg": 90704,
	"./Images/Svgs/tournament_banner/banner_main.svg": 33661,
	"./Images/Svgs/tournament_banner/bg_pattern.svg": 78167,
	"./Images/Svgs/tournament_banner/black_bg_pattern.svg": 22371,
	"./Images/Svgs/tournament_banner/calendar.svg": 54739,
	"./Images/Svgs/tournament_banner/check_icon.svg": 28865,
	"./Images/Svgs/tournament_banner/corner_prize.svg": 80367,
	"./Images/Svgs/tournament_banner/corner_prize_mobile.svg": 54512,
	"./Images/Svgs/tournament_banner/currency-circle.svg": 27861,
	"./Images/Svgs/tournament_banner/detail_pattern.svg": 14557,
	"./Images/Svgs/tournament_banner/gukesh.svg": 95820,
	"./Images/Svgs/tournament_banner/hat.svg": 64388,
	"./Images/Svgs/tournament_banner/image_1.svg": 13396,
	"./Images/Svgs/tournament_banner/image_2.svg": 84903,
	"./Images/Svgs/tournament_banner/image_3.svg": 97782,
	"./Images/Svgs/tournament_banner/onboarding_tournament.svg": 2644,
	"./Images/Svgs/tournament_banner/puzzle.svg": 55177,
	"./Images/Svgs/tournament_banner/yellowBg.svg": 29424,
	"./Images/Svgs/tournament_friends.svg": 98867,
	"./Images/Svgs/trend-up-01.svg": 60187,
	"./Images/Svgs/union.svg": 67793,
	"./Images/Svgs/userIcon.svg": 45666,
	"./Images/Svgs/wrong.svg": 33291,
	"./Images/Svgs/yellow.svg": 84356,
	"./Images/Svgs/yellowleft.svg": 89951,
	"./Images/Svgs/yellowright.svg": 96698,
	"./Images/Svgs/zero_assessments_state.svg": 18884,
	"./Images/Tournaments/no_pairing.svg": 62647,
	"./Images/Tournaments/no_standing.svg": 28937,
	"./Images/Tournaments/no_tournament_found.svg": 34381,
	"./Images/Workbook/WorkbookEmptyPage.svg": 21619,
	"./Images/bishop.png": 19104,
	"./Images/cursor-click.svg": 75057,
	"./Images/glyphs/thumbsdown.svg": 33951,
	"./Images/glyphs/thumbsup.svg": 31216,
	"./Images/glyphs/tick.svg": 36643,
	"./Images/hide.svg": 17436,
	"./Images/icons/Rematch.png": 99954,
	"./Images/icons/Rematch@2x.png": 71426,
	"./Images/icons/Rematch@3x.png": 79309,
	"./Images/icons/close.png": 48512,
	"./Images/icons/tick.png": 52805,
	"./Images/icons/tick@2x.png": 83727,
	"./Images/icons/tick@3x.png": 24324,
	"./Images/lock.png": 73286,
	"./Images/pawn.png": 70505,
	"./Images/png/PRO.png": 10058,
	"./Images/png/abort.png": 22541,
	"./Images/png/back_arrow.png": 27772,
	"./Images/png/badge.png": 6826,
	"./Images/png/beginners_curve.png": 26950,
	"./Images/png/black_box.png": 86724,
	"./Images/png/black_color.png": 30698,
	"./Images/png/black_rook.png": 94912,
	"./Images/png/book-closed.png": 12979,
	"./Images/png/book.png": 44316,
	"./Images/png/book_dummy.png": 21249,
	"./Images/png/bottom_left_square.png": 6524,
	"./Images/png/bottom_right_square.png": 60599,
	"./Images/png/casual_player.png": 35362,
	"./Images/png/challenge.png": 50872,
	"./Images/png/challenge@2x.png": 63008,
	"./Images/png/challenge@3x.png": 37259,
	"./Images/png/chapter.png": 96772,
	"./Images/png/chart.png": 54163,
	"./Images/png/chat.png": 70721,
	"./Images/png/checkmark.png": 6088,
	"./Images/png/chess_events.png": 99183,
	"./Images/png/chess_footer_background.png": 23858,
	"./Images/png/chessboard_left_part_large.png": 69723,
	"./Images/png/chessboard_part_left.png": 33631,
	"./Images/png/chessboard_part_placeholder.png": 46193,
	"./Images/png/chessboard_part_right.png": 83920,
	"./Images/png/chessboard_right_part_large.png": 53990,
	"./Images/png/circle_chess_logo.png": 46066,
	"./Images/png/circle_chess_logo_black.png": 55702,
	"./Images/png/circlechess_screenshot.png": 17108,
	"./Images/png/custom_rules_icon.png": 68988,
	"./Images/png/custom_rules_modal.png": 40148,
	"./Images/png/defeat_result.png": 48476,
	"./Images/png/delete.png": 31882,
	"./Images/png/diagonal_chess_part.png": 97687,
	"./Images/png/double_arrow_up.png": 35952,
	"./Images/png/draw.png": 72549,
	"./Images/png/draw_result.png": 59249,
	"./Images/png/dropdown.png": 16772,
	"./Images/png/elevate.png": 48317,
	"./Images/png/empty_book.png": 35646,
	"./Images/png/empty_result.png": 3586,
	"./Images/png/endgame.png": 7902,
	"./Images/png/engine.png": 8301,
	"./Images/png/eye.png": 56116,
	"./Images/png/file.png": 57441,
	"./Images/png/gamesummary.png": 21337,
	"./Images/png/go_back.png": 47207,
	"./Images/png/home.png": 50638,
	"./Images/png/intermediate.png": 66628,
	"./Images/png/late_guess.png": 92209,
	"./Images/png/learning.png": 34050,
	"./Images/png/level_unit_empty.png": 82422,
	"./Images/png/level_unit_filled.png": 17577,
	"./Images/png/master.png": 72433,
	"./Images/png/middlegame.png": 58742,
	"./Images/png/mobileOne.png": 39301,
	"./Images/png/newGame.png": 21015,
	"./Images/png/opening.png": 9691,
	"./Images/png/opening2.png": 66721,
	"./Images/png/organisation_trophy.png": 4920,
	"./Images/png/player.png": 18140,
	"./Images/png/random_color.png": 88814,
	"./Images/png/record_button.png": 70097,
	"./Images/png/refresh.png": 93306,
	"./Images/png/resign.png": 80283,
	"./Images/png/review_game.png": 71266,
	"./Images/png/search.png": 13775,
	"./Images/png/settings.png": 93196,
	"./Images/png/settings_close.png": 86301,
	"./Images/png/shopping-bag.png": 84466,
	"./Images/png/signup_assess.png": 62638,
	"./Images/png/signup_elevate.png": 78584,
	"./Images/png/signup_play.png": 74550,
	"./Images/png/square_background.png": 34359,
	"./Images/png/stockfish_settings.png": 94763,
	"./Images/png/stop_record.png": 4479,
	"./Images/png/trash.png": 66029,
	"./Images/png/upload.png": 30936,
	"./Images/png/voice_process.png": 50559,
	"./Images/png/whatsapp_say_hi.png": 84803,
	"./Images/png/whatsapp_share.png": 52933,
	"./Images/png/white_box.png": 39122,
	"./Images/png/white_color.png": 50832,
	"./Images/png/white_rook.png": 42650,
	"./Images/png/win_result.png": 43029,
	"./Sounds/Confirmation.mp3": 12422,
	"./Sounds/correct-sound-square-trainer.mp3": 83505,
	"./Sounds/draw_offer.mp3": 94480,
	"./Sounds/game_resign_countdown_sound.mp3": 19562,
	"./Sounds/game_start.mp3": 35986,
	"./Sounds/levelup.mp3": 39982,
	"./Sounds/notification.mp3": 25488,
	"./Sounds/round_start.mp3": 28490,
	"./Sounds/success.mp3": 84662,
	"./Sounds/wrong.mp3": 15424,
	"./blunderDashboardQuestion.svg": 24651,
	"./onboardingScreen1.svg": 4933,
	"./reset10Icon.svg": 57428
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44082;